(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-animation-text"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function () {
  var text = 'To dress real Indian women, really well. We create high-quality, joyful athleisure through a comfort-first approach—celebrating self-expression, movement, and everyday confidence';
  var container = $("#animatedText");

  // Wrap each character in span
  var chars = text.split('').map(function (char) {
    return '<span>' + char + '</span>';
  }).join('');
  container.html(chars);

  var spans = container.find("span");
  var index = 0;

  function revealNextChar() {
    if (index < spans.length) {
      $(spans[index]).addClass("revealed");
      index++;
      setTimeout(revealNextChar, 30);
    }
  }

  // Intersection observer via jQuery fallback
  function isInViewport(el) {
    var elementTop = el.offset().top;
    var elementBottom = elementTop + el.outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop + el.height() / 2 && elementTop < viewportBottom;
  }

  $(window).on("scroll", function () {
    if (isInViewport(container) && !container.hasClass("reveal")) {
      container.addClass("reveal");
      revealNextChar();
    }
  });

  // Trigger on load
  $(window).trigger("scroll");
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-video"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.video-block').forEach((block) => {
  const btn = block.querySelector('.play-btn');
  const video = block.querySelector('video');

  // Play video on button click
  btn.addEventListener('click', () => {
    video.play();
    btn.style.display = 'none';
  });

  // Show play button again when video ends
  video.addEventListener('ended', () => {
    btn.style.display = 'flex';
  });

  // Pause video on click and show play button again
  video.addEventListener('click', () => {
    if (!video.paused) {
      video.pause();
      btn.style.display = 'flex';
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-love-by"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const swiper = new Swiper('.community-swiper', {
      slidesPerView: 2.5,
      spaceBetween: 20,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
          el: '.swiper-pagination-pro',
      },
      breakpoints: {
        300: {
          slidesPerView: 1,
        },
        640: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 1,
        },
        1024: {
          slidesPerView: 2.5,
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();
})();
